const STORAGE_KEY = "lucentia_resources_registered";

export type ResourcesRegistration = {
  name: string;
  email: string;
};

export function getResourcesRegistration(): ResourcesRegistration | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as ResourcesRegistration;
    if (
      typeof parsed?.name === "string" &&
      typeof parsed?.email === "string" &&
      parsed.name.trim().length >= 2 &&
      parsed.email.trim().length > 0
    ) {
      return { name: parsed.name.trim(), email: parsed.email.trim() };
    }
  } catch {
    /* ignore */
  }
  return null;
}

export function setResourcesRegistration(data: ResourcesRegistration) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}
